// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import replaceHttpsImg from './lib/repalceHttpsImg'
import echarts from 'echarts'
import Echarts from './components/Echarts/'
import Loading from './components/Loading/'
import Toast from './components/Toast/'
import VueCropper from 'vue-cropper'
import { getCookie } from "./lib/utils"
import { api } from './lib/api'
import { getGlobalEvent } from './lib/eventEmitter';
const eventEmitter = getGlobalEvent()

Vue.config.productionTip = false
Vue.use(ElementUI)

//全局方法
Vue.prototype.replaceHttpsImg = replaceHttpsImg;
Vue.prototype.echarts = echarts;
Vue.prototype.api = api;
Vue.prototype.eventEmitter = eventEmitter
window.eventEmitter = eventEmitter
window.api = api

//全局组件
Vue.use(Echarts)
Vue.use(VueCropper)
Vue.use(Toast)
Vue.use(Loading)

//上传模块需要window对象
window.NickName = unescape(getCookie("KuGoo", "NickName")) || "";
window.kugouid = getCookie("KuGoo", "KugooID") || "";
window.token = getCookie("KuGoo", "t") || "";
window.appid = getCookie("KuGoo", "a_id") || "";
//window.mid = getCookie("KuGoo", "mid") || "";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js